import { c as _c } from "react/compiler-runtime";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import Image from "next/image";
export default function MentionsTypeaheadMenuItem(t0) {
  const $ = _c(27);
  const {
    index,
    isSelected,
    onClick,
    onMouseEnter,
    handle,
    display,
    picture,
    setRefElement
  } = t0;
  const t1 = "typeahead-item-" + index;
  const t2 = `${isSelected ? "tw-bg-iron-700" : "tw-bg-transparent"} tw-relative tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-justify-between tw-rounded-lg tw-border-none tw-px-2 tw-py-2 tw-text-left tw-text-white tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400`;
  let t3;
  if ($[0] !== handle || $[1] !== picture) {
    t3 = picture && <div className="tw-h-6 tw-w-6 tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-white/10"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-text-center"><Image src={getScaledImageUri(picture, ImageScale.W_AUTO_H_50)} alt={`Profile for ${handle}`} width={24} height={24} unoptimized={true} className="tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain" /></div></div></div>;
    $[0] = handle;
    $[1] = picture;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== handle) {
    t4 = <div className="tw-w-[12rem] tw-truncate tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-white">{handle}</div>;
    $[3] = handle;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== display) {
    t5 = <div className="tw-w-[12rem] tw-truncate tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{display}</div>;
    $[5] = display;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="tw-inline-flex tw-items-center tw-space-x-2">{t3}{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isSelected) {
    t8 = isSelected && <svg className="tw-ml-2 tw-h-5 tw-w-5 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[13] = isSelected;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="tw-inline-flex tw-w-full tw-items-center tw-justify-between">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onClick || $[19] !== onMouseEnter || $[20] !== t2 || $[21] !== t9) {
    t10 = <button onMouseEnter={onMouseEnter} onClick={onClick} type="button" className={t2}>{t9}</button>;
    $[18] = onClick;
    $[19] = onMouseEnter;
    $[20] = t2;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== setRefElement || $[24] !== t1 || $[25] !== t10) {
    t11 = <li className="tw-h-full" ref={setRefElement} id={t1}>{t10}</li>;
    $[23] = setRefElement;
    $[24] = t1;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}